<template>
  <div class="btn-width-main">
    <Card
      class="card-main"
      header-slot-class="bg-grayCust-50 px-6 py-5  rounded-lg rounded-bl-none rounded-br-none "
      main-slot-class="p-6"
      footer-slot-class="bg-grayCust-50 py-5 px-6 rounded-lg rounded-tl-none rounded-tr-none"
    >
      <template #header>
        <div class="flex justify-between items-center">
          <div class="flex items-center">
            <div
              class="w-9 h-9 cursor-pointer flex justify-center items-center border border-grayCust-770 bg-white rounded-lg"
              @click="closeAddCard"
            >
              <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.97508 5.44141L2.91675 10.4997L7.97508 15.5581"
                  stroke="#3F3F46"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17.0834 10.5H3.05835"
                  stroke="#3F3F46"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="ml-4 text-left">
              <div class="text-grayCust-430 lg:text-xl text-2xl font-semibold mb-1 font-jakarta">
                💳 Add Card
              </div>
              <div class="text-sm font-normal text-grayCust-910">
                Add your debit/credit card to make payments.
              </div>
            </div>
          </div>
          <div
            class="cursor-pointer"
            @click="closeAddCard"
          >
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 22.5C17.5 22.5 22 18 22 12.5C22 7 17.5 2.5 12 2.5C6.5 2.5 2 7 2 12.5C2 18 6.5 22.5 12 22.5Z"
                stroke="#A1A1AA"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.16992 15.3299L14.8299 9.66992"
                stroke="#A1A1AA"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.8299 15.3299L9.16992 9.66992"
                stroke="#A1A1AA"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </template>
      <template #main>
        <div class="mb-4">
          <label
            for="card_holder"
            class="inline-block text-sm font-medium text-grayCust-800 mb-1 "
          >Card holder name</label>
          <input
            id="card_holder"
            type="text"
            name="card_holder"
            placeholder="Enter Holder Name"
            class="block w-full rounded-md py-2 px-3 border-grayCust-350 shadow-sm focus:border-primary-900 focus:ring-1 focus:ring-primary-900 sm:text-sm"
          >
        </div>
        <div class="mb-4">
          <label
            for="credit-debit-card"
            class="inline-block text-sm font-medium text-grayCust-800 mb-1 "
          >Credit/Debit card</label>
          <input
            id="credit-debit-card"
            type="number"
            name="credit-debit-card"
            placeholder="Card number"
            class="block w-full rounded-t-md py-2.5 px-3 border-grayCust-350 shadow-sm focus:border-grayCust-350 focus:ring-0 sm:text-sm"
          >
          <div class="grid grid-cols-2">
            <div>
              <input
                id="credit-debit-card"
                type="number"
                name="credit-debit-card"
                placeholder="MM / YY"
                class="block w-full border-t-0 rounded-bl-md py-3 px-3 border-grayCust-350 shadow-sm focus:border-grayCust-350 focus:ring-0 sm:text-sm"
              >
            </div>
            <div>
              <input
                id="credit-debit-card"
                type="number"
                name="credit-debit-card"
                placeholder="CVC"
                maxlength="3"
                class="block w-full border-t-0 border-l-0 rounded-br-md py-3 px-3 border-grayCust-350 shadow-sm focus:border-grayCust-350 focus:ring-0 sm:text-sm"
              >
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="lg:grid-cols-2 grid-cols-1 grid gap-3">
          <button
            class="bg-white border w-full text-base py-2.5 px-4 text-grayCust-800  font-medium text-center rounded-md btn-shadow focus:outline-0 btn-focus focus-visible:outline-0"
            @click="closeAddCard"
          >
            {{
              $t('back') }}
          </button>
          <button
            class=" w-full bg-secondary-900 py-2.5 px-4 button-margin text-white text-base font-medium text-center rounded-md btn-shadow disabled:opacity-60 btn-focus primarySettings focus:outline-0 focus-visible:outline-0"
            @click="closeAddCard"
          >
            Save
          </button>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import Card from '@/Common/Card.vue';
export default {
   name: 'AddCard',
   components: {
      Card
   },
   methods: {
      closeAddCard() {
         this.$emit("close_addCard")
      }
   }
}
</script>
<style scoped>
.card-main {
   background: #FFFFFF;
   width: 562px;
   border-radius: 16px;
   box-shadow: 4px 4px 16px rgba(0, 0, 0, 0.06);
}




input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}


input[type=number] {
  -moz-appearance: textfield;
}

@media screen and (max-width:576px) {

   .card-main,
   .btn-width-main {
      width: 100%;
   }
}
</style>
